import { ChakraProvider } from '@chakra-ui/react';

import { ColorModeProvider } from '~/components/ui/color-mode';
import { Toaster } from '~/components/ui/toaster';
import system from '~/styles/theme';

interface ProviderProps {
  children: React.ReactNode;
}

export function Provider({ children }: ProviderProps) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider>
        {children}
        <Toaster />
      </ColorModeProvider>
    </ChakraProvider>
  );
}
